import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Text from './text';

import LoadingScreen from '^/components/molecules/LoadingScreenOld';
import SignInForm from '^/components/organisms/SignInForm';
import palette from '^/constants/palette';
import { useL10n, UseL10n } from '^/hooks';
import * as T from '^/types';
import { l10n } from '^/utilities/l10n';
import { resetSignInAPI } from '^/store/auth';
import { useSearchParamsQuery } from '^/hooks/useSearchParamsQuery';
import { useSAMLSSOMutation } from '^/store/react-query/auth';
import { usePlanConfig } from '^/hooks/usePlanConfig';
import AuthLayout from '^/components/organisms/AuthLayout';
import colorTokens from '^/theme/colors/color-tokens';
import AuthPageLogoContainer from '^/components/organisms/AuthPageLogoContainer';

const WelcomeText = styled.span({
  fontSize: '60px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '120%',
  marginBottom: '20px',
  color: colorTokens.textCoolDarker,
});
const SignInText = styled.span({
  fontSize: '16px',
  marginBottom: '20px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '120%',
  color: colorTokens.textCool,
});

const FormWrapper = styled.div({
  display: 'flex',
  width: '100%',
  height: '100%',
  maxWidth: '380px',
  margin: '0 auto',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '5px',
});
const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const LoginPage: FC = () => {
  const [, language]: UseL10n = useL10n();
  const searchParams = useSearchParamsQuery();
  const { mutate: mutateSAMLSSO } = useSAMLSSOMutation();

  const isPlanConfigLoaded: boolean = useSelector((state: T.State) =>
    Boolean(state.PlanConfig.config)
  );

  useEffect(() => {
    resetSignInAPI();
    return resetSignInAPI;
  }, []);

  usePlanConfig();

  useEffect(() => {
    const hasToken = searchParams.has('token');

    if (hasToken) {
      mutateSAMLSSO({ token: searchParams.get('token')! });
    }
  }, [searchParams]);

  if (!isPlanConfigLoaded || searchParams.has('token')) {
    return <LoadingScreen backgroundColor={palette.white} textColor={palette.textGray} />;
  }

  return (
    <AuthLayout>
      <AuthPageLogoContainer />
      <FormWrapper>
        <Wrapper>
          <WelcomeText>{l10n(Text.welcome, language)}</WelcomeText>
          <SignInText>{l10n(Text.signInText, language)}</SignInText>
        </Wrapper>
        <SignInForm />
      </FormWrapper>
    </AuthLayout>
  );
};

export default LoginPage;
